import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Flex,
  Text,
  Button,
  FormContext,
  ModalContext,
  IInputProps,
} from 'dash-ui';

import {
  GetSaleTeamsForPropertySelectQuery,
  useGetSaleTeamsForPropertySelectQuery,
} from 'gql/generated.graphql';
import { FormFields } from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/constants/constants';

import { DeleteSaleTeamModal, SaleTeamItem } from './components';

function SaleTeams(props: IInputProps) {
  const { t } = useTranslation('pages');
  const { toggleModal, setPayload } = useContext(ModalContext);

  const { formState, setFormValues } = useContext(FormContext);

  const { data } = useGetSaleTeamsForPropertySelectQuery({
    variables: {
      filter: {
        internalTeamsByOrganizationIds: formState.primaryOrganization,
      },
    },
    fetchPolicy: 'network-only',
  });

  const saleTeams = useMemo(() => data?.getSaleTeams?.collection || [], [data]);

  function onAddSaleTeamClick() {
    setFormValues({
      ...formState,
      saleTeams: [...(formState.saleTeams || []), {}],
    });
  }

  function onDeleteSaleTeamClick(indexToRemove: number) {
    setFormValues({
      ...formState,
      saleTeams: (formState.saleTeams || []).filter(
        (_: any, index: number) => index !== indexToRemove
      ),
    });
  }

  const selectedSaleTeams = formState[FormFields.SaleTeams] || [];
  const selectedSaleTeamIds: string[] = selectedSaleTeams.map(
    (doc: any) => doc.saleTeamId
  );
  const allowedToAdd = saleTeams.some(
    (saleTeam) => !selectedSaleTeamIds.includes(saleTeam._id)
  );

  return (
    <Box>
      <DeleteSaleTeamModal onDeleteSaleTeamClick={onDeleteSaleTeamClick} />
      <Flex alignItems="center" justifyContent="space-between" w="100%">
        <Text bold lg>
          {t('propertyPage.salesTeam')}
        </Text>
        <Button
          type="button"
          variation="flat"
          onClick={onAddSaleTeamClick}
          icon="plus"
          disabled={!allowedToAdd || props.disabled}
        >
          {t('pages:propertyPage.addSaleTeam')}
        </Button>
      </Flex>
      <Box>
        {formState[FormFields.SaleTeams]?.map((_: any, index: number) => (
          <SaleTeamItem
            saleTeamIndex={index}
            key={index}
            saleTeamsList={
              saleTeams as GetSaleTeamsForPropertySelectQuery['getSaleTeams']['collection']
            }
            onDeleteSaleTeamClick={(indexToRemove) => {
              setPayload(indexToRemove);
              toggleModal(true, 'DeleteSaleTeamModal');
            }}
            disabled={props.disabled}
          />
        ))}
      </Box>
    </Box>
  );
}

export default SaleTeams;
